import React from 'react';
import { cn } from '@/lib/utils';

const COUNT_BADGE_ATTENTION_BACKGROUND = '#f87171';
const COUNT_BADGE_NEUTRAL_BACKGROUND = '#9ca3af';

export const formatCountBadgeLabel = (count: number, maxDisplay = 99): string => {
  if (count > maxDisplay) {
    return `${maxDisplay}+`;
  }
  return String(count);
};

type CountBadgeProps = {
  count: number;
  mode?: 'overlay' | 'inline';
  tone?: 'attention' | 'neutral';
  maxDisplay?: number;
  className?: string;
};

export const CountBadge: React.FC<CountBadgeProps> = ({
  count,
  mode = 'overlay',
  tone = 'attention',
  maxDisplay = 99,
  className,
}) => {
  if (count <= 0) {
    return null;
  }

  return (
    <span
      data-testid="count-badge"
      data-tone={tone}
      className={cn(
        'flex h-5 min-w-5 items-center justify-center rounded-full px-1 text-[10px] font-medium tabular-nums text-white',
        mode === 'overlay' && 'absolute top-0 right-0 translate-x-1 -translate-y-1',
        mode === 'inline' && 'ml-auto shrink-0',
        className,
      )}
      style={{
        backgroundColor:
          tone === 'neutral' ? COUNT_BADGE_NEUTRAL_BACKGROUND : COUNT_BADGE_ATTENTION_BACKGROUND,
      }}
    >
      {formatCountBadgeLabel(count, maxDisplay)}
    </span>
  );
};
